// defaultsDeep doesn't work well with arrays. It doesn't replace the arrays.
// deepMerge addresses that issue using lodash functions.

import { isArray, mergeWith } from 'lodash';

// keeping the function parameter order same as defaultsDeep
export const deepMerge = (target: any, newSource: any, oldSource: any) => {
  // if the attribute is of type Array then new array will replace the old array. we don't merge the arrays.
  return mergeWith(target, oldSource, newSource, (a, b) => (isArray(b) || isArray(a) ? b : undefined));
};
